import { render, staticRenderFns } from "./TablePaginationControls.vue?vue&type=template&id=ecf8bb56&scoped=true&"
import script from "./TablePaginationControls.vue?vue&type=script&lang=js&"
export * from "./TablePaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginationControls.vue?vue&type=style&index=0&id=ecf8bb56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf8bb56",
  null
  
)

export default component.exports